import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { Subject } from 'rxjs';

export class CustomInfiniteScrollNextPageManager<T> {

  /** Internal subject  */
  private _loadNextPage = new Subject<number>();

  /**
   * Observable which is triggered when the scroll container
   * needs the next page.
   */
  public nextPageNeeded = this._loadNextPage.asObservable();

  /**
   * Internally used to track the highest page we have asked for.
   * This prevents us from attempting to fetch pages
   * which were already fetched, especially when the scroll
   * container is scrolled up.
   */
  private _highestFetchedPage = 0;

  /**
   *
   * @param scrollviewport A reference to the scroll viewport
   * @param pageSize The number of items which are retrieved per page
   * this is used to calculate what page the scroll container
   * is currently scrolled into, and what the next page will be.
   */
  constructor(
    private scrollviewport: CdkVirtualScrollViewport,
    private pageSize = 20
  ) {
    this.init();
  }

  /**
   * Resets the page counter back to 0
   */
  reset() {
    this._highestFetchedPage = 0;
    this._loadNextPage.next(this._highestFetchedPage);
  }

  private init() {

    // Checks if data should load more
    this.scrollviewport.renderedRangeStream.pipe(
      // Don't fetch data where we already have fetched the highest scroll index
      // filter(index => index > this.highestScrollIndex),
      // tap(index => this.highestScrollIndex = index)

    ).subscribe(({ start, end }) => {
      const nextPageToFetch = this.calcNextPage(end);
      if (nextPageToFetch > this._highestFetchedPage) {
        this._highestFetchedPage = nextPageToFetch;
        this._loadNextPage.next(this._highestFetchedPage);
      }
    });

  }

  private calcNextPage(end: number) {
    const buffer = 1;
    return  Math.ceil( (end + buffer) / this.pageSize) - 1;
  }

}
